import styled, { css } from 'styled-components';
import { handleWidth, handleFontSize } from '../../styles/util';

export const Container = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Imagem = styled.img`
  width: ${({ size }) => handleWidth(size)};
  display: inline-block;
`;

export const Nome = styled.span`
  font-size: ${({ size }) => handleFontSize(size)};
  font-weight: 300;
  color: ${props => {
    if (props.textWhite) return '#FFF';
    return '#0D364A';
  }};
  ${props =>
    props.iscollapsed &&
    css`
      display: none;
    `}
`;
